<sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true" class="station-details no-field-space">
  <div>
    <sc-flex>
      <mat-form-field appearance="fill">
        <mat-label>{{'identifier' | translate: ['tmc.yard.entity.station.identifier',
          translationService.language]}}</mat-label>
        <input [(ngModel)]="station.identifier" #ctrlIdentifier="ngModel" name="identifier" matInput [required]="true"
          [maxlength]="255" />
      </mat-form-field>
      <sc-content-spacer></sc-content-spacer>
      <mat-form-field appearance="fill" style="flex-grow:1;">
        <mat-label>{{'name' | translate: ['tmc.yard.entity.station.name', translationService.language]}}
        </mat-label>
        <input [(ngModel)]="station.name" #ctrlName="ngModel" name="name" matInput [required]="true"
          [maxlength]="255" />
      </mat-form-field>
      <sc-content-spacer></sc-content-spacer>
      <mat-form-field appearance="fill" style="flex-grow:1;">
        <mat-label>{{'name for messaging' | translate: ['tmc.yard.entity.station.name-for-messaging',
          translationService.language]}}
        </mat-label>
        <input [(ngModel)]="station.nameForMessaging" #ctrlName="ngModel" name="nameForMessaging" matInput
          [required]="true" [maxlength]="255" />
      </mat-form-field>
    </sc-flex>
  </div>

  <sc-content-spacer [vertical]="true"></sc-content-spacer>

  <div>
    <sc-flex>
      <mat-form-field appearance="fill" style="flex-grow:1;">
        <mat-label>{{'type' | translate: ['tmc.yard.entity.station.type', translationService.language]}}
        </mat-label>
        <mat-select [(ngModel)]="station.stationType" #ctrlType="ngModel" name="stationType" [required]="true">
          <mat-option *ngFor="let stationTyp of keys(stationTypes)" [value]="stationTyp">
            {{stationTypes[stationTyp] | translate: ['tmc-yard.common.enum.station-type.' + stationTypes[stationTyp],
            translationService.language]}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <sc-content-spacer></sc-content-spacer>
      <mat-form-field appearance="fill" style="flex-grow:1;">
        <mat-label>{{'internal' | translate: ['tmc.yard.entity.station.internal', translationService.language]}}
        </mat-label>
        <input [(ngModel)]="station.internal" #ctrlInternal="ngModel" name="internal" matInput [required]="false"
          [maxlength]="255" />
      </mat-form-field>
    </sc-flex>
  </div>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <mat-form-field appearance="fill">
    <mat-label>{{'description' | translate: ['tmc.yard.entity.station.description', translationService.language]}}
    </mat-label>
    <textarea [(ngModel)]="station.description" #ctrlDescription="ngModel" name="description" matInput
      [required]="false" [maxlength]="255"></textarea>
  </mat-form-field>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <ng-container *ngIf="station.isWaitingArea()">
    <sc-flex>
      <mat-form-field appearance="fill" style="flex-grow:1;">
        <mat-label>{{'capacity' | translate: ['tmc.yard.entity.station.capacity', translationService.language]}}
        </mat-label>
        <input type="number" [(ngModel)]="station.capacity" #ctrlCapacity="ngModel" name="capacity" matInput appPositiveInteger min="0" [required]="true" [maxlength]="4" />
      </mat-form-field>

      <sc-content-spacer></sc-content-spacer>

      <mat-form-field appearance="fill" style="flex-grow:1;">
        <mat-label>{{'type' | translate: ['tmc.yard.entity.station.retrievalStrategy', translationService.language]}}</mat-label>
        <mat-select [(ngModel)]="station.retrievalStrategy" #ctrlType="ngModel" name="retrievalStrategy">
          <mat-option *ngFor="let retrievalStrategy of possibleRetrievalStrategies" [value]="retrievalStrategy.value">
            {{retrievalStrategy.labelDictionaryKey| translate: [retrievalStrategy.labelDictionaryKey, translationService.language]}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </sc-flex>
    <sc-content-spacer [vertical]="true"></sc-content-spacer>
  </ng-container>
  <mat-form-field appearance="fill">
    <mat-label>{{'externalKey' | translate: ['tmc.yard.entity.station.externalKey', translationService.language]}}
    </mat-label>
    <input [(ngModel)]="station.externalKey" #ctrlExternalKey="ngModel" name="externalKey" matInput [required]="true"
      [maxlength]="50" [minlength]="1" />
  </mat-form-field>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <mat-form-field appearance="fill">
    <mat-label>{{'referenceDuration' | translate: ['tmc.yard.entity.station.referenceDuration',
      translationService.language]}}</mat-label>
    <input [(ngModel)]="station.referenceDuration" #ctrlReferenceDuration="ngModel" name="referenceDuration" matInput
      appPositiveInteger type="number" min="0" [required]="false" />
  </mat-form-field>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <div>
    <sc-flex>
      <mat-checkbox [(ngModel)]="station.suggestNextTransport" name="suggestNextTransport">
        {{'suggest next transport' | translate: ['tmc.yard.entity.station.suggestNextTransport',
        translationService.language]}}
      </mat-checkbox>
      <sc-content-spacer></sc-content-spacer>
      <mat-checkbox [(ngModel)]="station.disabled" name="disabled">
        {{'disabled' | translate: ['tmc.yard.entity.station.disabled', translationService.language]}}
      </mat-checkbox>
      <sc-content-spacer></sc-content-spacer>
      <mat-checkbox [(ngModel)]="station.opened" name="opened" [disabled]="true">
        {{'opened' | translate: ['tmc.yard.entity.station.opened', translationService.language]}}
      </mat-checkbox>
    </sc-flex>
  </div>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <div>
    <sc-flex>
      <mat-checkbox [(ngModel)]="station.plannedTransportAssignmentPossible" name="plannedTransportAssignmentPossible">
        {{'planned transport assignment possible' | translate:
        ['tmc.yard.entity.station.planned-transport-assignment-possible', translationService.language]}}
      </mat-checkbox>
      <sc-content-spacer></sc-content-spacer>
      <div>
        <mat-form-field appearance="fill" style="width: 300px;">
          <mat-label>{{'buffer zone' | translate: ['tmc.yard.entity.station.buffer-zone',
            translationService.language]}}</mat-label>
          <input matInput [(ngModel)]="bufferZoneName" #ctrlBufferZoneId="ngModel" name="bufferZoneId" [required]="false"
            [readonly]="true" [disabled]="!componentsForPlannedAssignmentVisible">
          <button mat-icon-button matSuffix type="button" (click)="assignBufferZone()" class="small-button assign-button"
            [disabled]="!componentsForPlannedAssignmentVisible"><mat-icon><i
                class="fa-light fa-sitemap"></i></mat-icon></button>
        </mat-form-field>
      </div>
    </sc-flex>
  </div>

  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <sc-title>{{'transport creation profiles' | translate: ['tmc.yard.entity.station.transport-creation-profiles',
    translationService.language]}}</sc-title>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>

  <sc-flex-fitting-content [vertical]="true">
    <sc-scroll-pane [minHeight]="200">
      <div class="transport-creation-profile-list" cdkDropList (cdkDropListDropped)="dropProfile($event)">
        <div class="draggable-form-box transport-creation-profile" cdkDrag
          *ngFor="let profile of station.transportCreationProfiles">

          <sc-read-only-field class="display-name"
            [label]="'display name' | translate: ['tmc.yard.entity.station.transport-creation-profiles.display-name', translationService.language]"
            [value]="profile.name">
          </sc-read-only-field>

          <div class="delete-button-wrapper">
            <sc-icon iconClass="fa-trash" (click)="removeTransportCreationProfile(profile)"></sc-icon>
          </div>
        </div>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <div class="button-wrapper">
          <button class="add-button" mat-flat-button type="button" (click)="addTransportCreationProfile()">
            <sc-icon iconClass="fa-plus fa-2x"></sc-icon>
          </button>
        </div>
      </div>
    </sc-scroll-pane>
  </sc-flex-fitting-content>
</sc-flex>
